<template>
  <a-upload
      :disabled="info.status !== 'edit'"
      :file-list="fileList"
      accept="video/*"
      list-type="picture-card"
      @change="onChange"
      @preview="handlePreview"
      :multiple="widget.multi"
      :custom-request="cosUploader"
      :is-image-url="() => false"
  >
    <div v-if="info.status === 'edit'" style="margin-top: 8px;display: flex;flex-direction: column;">
      上传
      <span>{{ info.desc }}</span>
    </div>
  </a-upload>
  <a-modal
      :footer="null"
      :title="previewTitle"
      v-if="previewVisible"
      :visible="true"
      @cancel="handleCancel"
  >
    <video :src="previewImage" controls style="width: 100%"/>
  </a-modal>
</template>

<script lang="ts">

import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: "normal", show: "normal"}
});
</script>

<script lang="ts" setup>
import {computed, defineProps, onUnmounted, ref} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import {UploadChangeParam, UploadProps} from "ant-design-vue";
import {VideoFieldType} from "@/components/business/crud/interface/FieldType";
import {useCosUploader} from "@/components/business/crud/widgets/impl/component/cosUploader";

const props = defineProps<{
  propName: string;
  widget: VideoFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();
const cosUploader = useCosUploader();

const uploadList = ref<Exclude<UploadProps['fileList'], undefined>>([]);
const previewVisible = ref(false);
const previewImage = ref('');
const previewTitle = ref('');

const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = '';
};
const handlePreview = async (file: any) => {
  previewImage.value = file.url;
  previewVisible.value = true;
  previewTitle.value =
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};

const fileList = computed(() => {
  let res: Exclude<UploadProps['fileList'], undefined> = [];
  if (data.value[props.propName]) {
    if (typeof data.value[props.propName] === 'string') {
      res.push({
        uid: data.value[props.propName],
        name: data.value[props.propName],
        status: 'done',
        url: data.value[props.propName],
      });
    } else {
      res = data.value[props.propName].map((item: string) => {
        return {
          uid: item,
          name: item,
          status: 'done',
          url: item,
        };
      });
    }
  }
  return res.concat(...uploadList.value);
})

function onChange(info: UploadChangeParam) {
  uploadList.value = info.fileList.filter((file) => file.status !== 'done');
  const file = info.file;
  if (file.status === 'removed') {
    if (props.widget.multi) {
      if (data.value[props.propName]) {
        if (!(data.value[props.propName] instanceof Array)) {
          data.value[props.propName] = [data.value[props.propName]];
        }
        data.value[props.propName] = data.value[props.propName].filter(
            (id: string) => id !== file.uid
        );
      }
    } else {
      data.value[props.propName] = null;
    }
  } else if (file.status === 'done') {
    if (props.widget.multi) {
      if (!data.value[props.propName]) {
        data.value[props.propName] = [];
      }
      if (!(data.value[props.propName] instanceof Array)) {
        data.value[props.propName] = [data.value[props.propName]];
      }
      data.value[props.propName].push(file.response.path);
    } else {
      data.value[props.propName] = file.response.path;
    }
  }
}
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}

.show-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  .img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin: 0 5px 5px 0;
    cursor: pointer;
  }
}
</style>
